module.exports = __webpack_public_path__ + "static/media/user_input_2.78873c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindRose/user_input_2.png
// module id = 2500
// module chunks = 0